function getPublicSharingSettings(collaborators, role) {
  const sharingSettings = collaborators.
  filter(({ public: isPublic, organisation }) => isPublic && !organisation);

  return sharingSettings && sharingSettings.length ?
  sharingSettings[0] :
  { public: true, role, password: void 0 };
}

function getWorkspaceSharingSettings(collaborators, role) {
  const sharingSettings = collaborators.
  filter(({ public: isPublic, organisation, organisationId }) =>
  !isPublic && (organisation || organisationId)
  );

  return sharingSettings && sharingSettings.length ?
  sharingSettings[0] :
  { public: false, canSearch: false, organisation: void 0, role };
}

export function getLinkSharingSettings(
collaborators,
workspaceRole,
publicRole)
{
  const sharingSettings = collaborators.
  filter(({ userId, teamId }) => !userId && !teamId);

  return {
    publicSettings: getPublicSharingSettings(sharingSettings, publicRole),
    workspaceSettings: getWorkspaceSharingSettings(sharingSettings, workspaceRole)
  };
}